
export enum AuditAction {
  LOGIN = 'login',
  SEARCH = 'search',
  VIEW = 'view',
  ADD = 'add',
  DELETE = 'delete',
  SHARE = 'share',
  MODERATE = 'moderate',
  ADMIN = 'admin',
}

export enum UserStatus {
  ACTIVE = 'active',
  DISABLED = 'disabled',
}

export enum SortOption {
  RELEVANCE = 'relevance',
  DATE = 'date',
  NAME = 'name',
  CITATIONS = 'citations',
}

export enum FavouriteItemType {
  JOURNAL = 'journal',
  RESOURCE = 'resource',
  COLLECTION = 'collection',
}

export enum ConnectionLayout {
  COSE = 'cose',
  CIRCLE = 'circle',
  BREADTHFIRST = 'breadthfirst',
  GRID = 'grid',
}

export enum MfaChallengeType {
  SMS_MFA = 'SMS_MFA',
  SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
}
